import { Exclude, Expose, Type } from 'class-transformer';
import { GroupTraitCategory } from './group-trait-category';

@Exclude()
export class GroupTrait {
  @Expose()
  id: number;

  @Expose()
  name: string;

  @Expose()
  description: string;

  @Expose()
  @Type(() => GroupTraitCategory)
  categories: GroupTraitCategory[];
}
